import { Component, Input, OnInit, OnChanges } from '@angular/core'

@Component({
  standalone: false,
  // tslint:disable-next-line:component-selector
  selector: 'pop-up-content',
  templateUrl: './pop-up-content.component.html',
  styleUrls: ['./pop-up-content.component.scss']
})
export class PopUpContentComponent implements OnInit, OnChanges {
  @Input() type = 'none'
  @Input() id: any
  idElement: any

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.id) {
      this.idElement = this.id;
    }
  }
}
